import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-eefcb0d0")

_pushScopeId("data-v-eefcb0d0")
const _hoisted_1 = { class: "button-container" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Marginal")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Standard")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Total Income: ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Deductions: ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Deductions: ")
const _hoisted_7 = {
  id: "standard-animation",
  class: "animation-wrapper"
}
const _hoisted_8 = { class: "income bar-container pointer-pop" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "nubbin" }, null, -1)
const _hoisted_10 = { class: "deductions bar-container pointer-pop" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "nubbin" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "nubbin" }, null, -1)
const _hoisted_13 = {
  id: "marginal-animation",
  class: "animation-wrapper"
}
const _hoisted_14 = { class: "income bar-container pointer-pop" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "nubbin" }, null, -1)
const _hoisted_16 = { class: "deductions bar-container pointer-pop" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "nubbin" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "nubbin" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "nubbin" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "nubbin" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "nubbin" }, null, -1)
const _hoisted_22 = { class: "tax-marginal-relief-notice tax-amount" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Tax and long-term care = ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Percentage of all income")
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" = ")
const _hoisted_26 = {
  key: 0,
  class: "tax-marginal-relief-notice unused-child-allowance"
}
const _hoisted_27 = { class: "tax-marginal-relief-notice" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Marginal relief has reduced your tax and long-term care by ")
const _hoisted_29 = { class: "tax-marginal-relief-notice tax-amount" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Tax and long-term care = ")
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Percentage of all income")
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" = ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_col = _resolveComponent("ion-col")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_row = _resolveComponent("ion-row")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_grid = _resolveComponent("ion-grid")

  return (_openBlock(), _createBlock(_component_ion_grid, { class: "tax-widget" }, {
    default: _withId(() => [
      _createVNode(_component_ion_row, { class: "left-right" }, {
        default: _withId(() => [
          _createVNode(_component_ion_col, { class: "left labels" }, {
            default: _withId(() => [
              _createVNode("h4", null, _toDisplayString(_ctx.title || ""), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_ion_col, { class: "right" }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode(_component_ion_button, {
                  class: ["button", { active: _ctx.toggleMarginal }],
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleMarginal = true)),
                  fill: "clear"
                }, {
                  default: _withId(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_ion_button, {
                  class: ["button", { active: !_ctx.toggleMarginal }],
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleMarginal = false)),
                  fill: "clear"
                }, {
                  default: _withId(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["class"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_row, { class: "left-right" }, {
        default: _withId(() => [
          _createVNode(_component_ion_col, { class: "left labels" }, {
            default: _withId(() => [
              _createVNode("div", null, [
                _hoisted_4,
                _createVNode("strong", null, "£" + _toDisplayString(_ctx.numberWithCommas(_ctx.salary_income.total)), 1)
              ]),
              _withDirectives(_createVNode("div", null, [
                _hoisted_5,
                _createVNode("strong", null, "£" + _toDisplayString(_ctx.numberWithCommas(_ctx.marginal_deductions.toFixed(0))), 1)
              ], 512), [
                [_vShow, _ctx.toggleMarginal]
              ]),
              _withDirectives(_createVNode("div", null, [
                _hoisted_6,
                _createVNode("strong", null, "£" + _toDisplayString(_ctx.numberWithCommas(_ctx.work_pension_deductions.total)), 1)
              ], 512), [
                [_vShow, !_ctx.toggleMarginal]
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_ion_col, { class: "right" }, {
            default: _withId(() => [
              _withDirectives(_createVNode("div", null, [
                _createVNode("div", _hoisted_7, [
                  _createVNode("div", _hoisted_8, [
                    _createVNode("div", {
                      class: "earned",
                      style: {
                  width: _ctx.income_split.total_income + '%',
                  opacity: _ctx.income_split.total_income > 0 ? 1 : 0,
                },
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDetails($event, _ctx.salary_income.details)))
                    }, [
                      _hoisted_9
                    ], 4)
                  ]),
                  _createVNode("div", _hoisted_10, [
                    _createVNode("div", {
                      class: "work-pension-deductions",
                      style: {
                  width:
                    _ctx.standard_taxable_income_split.work_pension_deductions + '%',
                  opacity:
                    _ctx.standard_taxable_income_split.work_pension_deductions > 0
                      ? 1
                      : 0,
                },
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showDetails($event, _ctx.work_pension_deductions.details)))
                    }, [
                      _hoisted_11
                    ], 4),
                    _createVNode("div", {
                      class: "taxable-income",
                      style: {
                  width:
                    _ctx.standard_taxable_income_split.total_taxable_income + '%',
                  opacity:
                    _ctx.standard_taxable_income_split.total_taxable_income > 0
                      ? 1
                      : 0,
                },
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showDetails($event, _ctx.standard_taxable_income.details)))
                    }, [
                      _hoisted_12
                    ], 4)
                  ])
                ])
              ], 512), [
                [_vShow, !_ctx.toggleMarginal]
              ]),
              _withDirectives(_createVNode("div", null, [
                _createVNode("div", _hoisted_13, [
                  _createVNode("div", _hoisted_14, [
                    _createVNode("div", {
                      class: "earned",
                      style: {
                  width: _ctx.income_split.total_income + '%',
                  opacity: _ctx.income_split.total_income > 0 ? 1 : 0,
                },
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showDetails($event, _ctx.salary_income.details)))
                    }, [
                      _hoisted_15
                    ], 4)
                  ]),
                  _createVNode("div", _hoisted_16, [
                    _createVNode("div", {
                      class: "total-tax-threshold",
                      style: {
                  width: _ctx.deductions_split.tax_threshold_split + '%',
                  opacity: _ctx.deductions_split.tax_threshold_split > 0 ? 1 : 0,
                },
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showDetails($event, _ctx.total_tax_threshold.details)))
                    }, [
                      _hoisted_17
                    ], 4),
                    _createVNode("div", {
                      class: "other-expenses",
                      style: {
                  width: _ctx.deductions_split.other_allowances_split + '%',
                  opacity: _ctx.deductions_split.other_allowances_split > 0 ? 1 : 0,
                },
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showDetails($event, _ctx.other_allowances.details)))
                    }, [
                      _hoisted_18
                    ], 4),
                    _createVNode("div", {
                      class: "work-pension-deductions",
                      style: {
                  width: _ctx.deductions_split.work_pension_deductions_split + '%',
                  opacity:
                    _ctx.deductions_split.work_pension_deductions_split > 0 ? 1 : 0,
                },
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showDetails($event, _ctx.work_pension_deductions.details)))
                    }, [
                      _hoisted_19
                    ], 4),
                    _createVNode("div", {
                      class: "second-earner-deductions",
                      style: {
                  width: _ctx.deductions_split.second_earners_split + '%',
                  opacity: _ctx.deductions_split.second_earners_split > 0 ? 1 : 0,
                },
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showDetails($event, _ctx.second_earners.details)))
                    }, [
                      _hoisted_20
                    ], 4),
                    _createVNode("div", {
                      class: "taxable-income",
                      style: {
                  width: _ctx.deductions_split.taxable_income_split + '%',
                  opacity: _ctx.deductions_split.taxable_income_split > 0 ? 1 : 0,
                },
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showDetails($event, _ctx.marginal_taxable_income.details)))
                    }, [
                      _hoisted_21
                    ], 4)
                  ])
                ])
              ], 512), [
                [_vShow, _ctx.toggleMarginal]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_row, null, {
        default: _withId(() => [
          _withDirectives(_createVNode(_component_ion_col, null, {
            default: _withId(() => [
              _createVNode("p", _hoisted_22, [
                _hoisted_23,
                _createVNode("strong", {
                  class: "pointer-pop",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showDetails($event, _ctx.standard_tax.details)))
                }, "£" + _toDisplayString(_ctx.numberWithCommas(_ctx.standard_tax.total.toFixed(2))), 1)
              ]),
              _createVNode("p", {
                class: "tax-marginal-relief-notice itis-rate",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showHelp($event, 'This is not the same percentage as your ITIS rate, which may take into account any tax you owe from earlier years, any shortfall you have in the current year and any extra credit you have paid.')))
              }, [
                _hoisted_24,
                _createVNode(_component_ion_icon, { icon: _ctx.helpCircleOutline }, null, 8, ["icon"]),
                _hoisted_25,
                _createVNode("strong", null, _toDisplayString(_ctx.standard_tax_percentage.toFixed(2)) + "%", 1)
              ])
            ]),
            _: 1
          }, 512), [
            [_vShow, !_ctx.toggleMarginal]
          ]),
          _withDirectives(_createVNode(_component_ion_col, null, {
            default: _withId(() => [
              (_ctx.unUsedChildAllowance > 0 && _ctx.independent === true)
                ? (_openBlock(), _createBlock("p", _hoisted_26, " This calculator automatically shares the child allowance equally between you and your spouse or civil partner. Your income means that some or all of the allowance is not being used. When you are independently taxed you may share your available child allowances between you in the most tax efficient way. "))
                : _createCommentVNode("", true),
              _createVNode("p", _hoisted_27, [
                _hoisted_28,
                _createVNode("strong", null, "£" + _toDisplayString(_ctx.numberWithCommas(_ctx.marginal_relief.toFixed(0))), 1)
              ]),
              _createVNode("p", _hoisted_29, [
                _hoisted_30,
                _createVNode("strong", {
                  class: "pointer-pop",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showDetails($event, _ctx.marginal_tax.details)))
                }, "£" + _toDisplayString(_ctx.numberWithCommas(_ctx.marginal_tax.total.toFixed(2))), 1)
              ]),
              _createVNode("p", {
                class: "tax-marginal-relief-notice itis-rate",
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showHelp($event, 'This is not the same percentage as your ITIS rate, which may take into account any tax you owe from earlier years, any shortfall you have in the current year and any extra credit you have paid.')))
              }, [
                _hoisted_31,
                _createVNode(_component_ion_icon, { icon: _ctx.helpCircleOutline }, null, 8, ["icon"]),
                _hoisted_32,
                _createVNode("strong", null, _toDisplayString(_ctx.marginal_tax_percentage.toFixed(2)) + "%", 1)
              ])
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.toggleMarginal]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})